var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c("dd-header"),
      _vm._v(" "),
      _c("div", { staticClass: "content_main" }, [
        _c("h1", [_vm._v("アップロード内容の確認")]),
        _vm._v(" "),
        _c("section", { staticClass: "confirm_sec" }, [
          _c("h3", [_vm._v("スケッチ画像")]),
          _vm._v(" "),
          _c("div", { staticClass: "img_list" }, [
            _c(
              "ul",
              { staticClass: "sketch_list" },
              _vm._l(_vm.inputForm.upImgList, function(image, index) {
                return _c("li", { key: "upimage-" + index }, [
                  _c("img", { attrs: { src: image } })
                ])
              })
            )
          ]),
          _vm._v(" "),
          _c("h3", [_vm._v("コメント")]),
          _vm._v(" "),
          _c("div", { attrs: { id: "confirm_comment" } }, [
            _vm._v(_vm._s(_vm.inputForm.comment))
          ])
        ]),
        _vm._v(" "),
        _c(
          "section",
          { staticClass: "confirm_sec", attrs: { id: "upload_confirm" } },
          [
            _c("h3", [_vm._v("入力内容")]),
            _vm._v(" "),
            _c("ul", [
              _c("li", [
                _c("div", [_vm._v("メールアドレス:")]),
                _vm._v(" "),
                _c("div", [_vm._v(_vm._s(_vm.inputForm.email))])
              ]),
              _vm._v(" "),
              _c("li", [
                _c("div", [_vm._v("氏名:")]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.inputForm.lastName) +
                      " " +
                      _vm._s(_vm.inputForm.firstName)
                  )
                ])
              ]),
              _vm._v(" "),
              _c("li", [
                _c("div", [_vm._v("氏名（カナ）:")]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.inputForm.lastNameKana) +
                      " " +
                      _vm._s(_vm.inputForm.firstNameKana)
                  )
                ])
              ]),
              _vm._v(" "),
              _c("li", [
                _c("div", [_vm._v("お届け先の郵便番号:")]),
                _vm._v(" "),
                _c("div", [_vm._v(_vm._s(_vm.inputForm.postcd))])
              ]),
              _vm._v(" "),
              _c("li", [
                _c("div", [_vm._v("連絡先電話番号:")]),
                _vm._v(" "),
                _c("div", [_vm._v(_vm._s(_vm.inputForm.tel))])
              ]),
              _vm._v(" "),
              _c("li", [
                _c("div", [_vm._v("設置場所について:")]),
                _vm._v(" "),
                _c("div", [_vm._v(_vm._s(_vm.locationLabel))])
              ]),
              _vm._v(" "),
              _c("li", [
                _c("div", [_vm._v("エレベーター有り:")]),
                _vm._v(" "),
                _c("div", [_vm._v(_vm._s(_vm.isElevetorFlg))])
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c("section", { staticClass: "scroll_rule" }, [_c("dd-userule")], 1),
        _vm._v(" "),
        _c("div", { staticClass: "form_submit" }, [
          _c("div", { staticClass: "cb" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.isPricyConsent,
                  expression: "isPricyConsent"
                }
              ],
              attrs: { type: "checkbox", name: "consent" },
              domProps: {
                checked: Array.isArray(_vm.isPricyConsent)
                  ? _vm._i(_vm.isPricyConsent, null) > -1
                  : _vm.isPricyConsent
              },
              on: {
                change: function($event) {
                  var $$a = _vm.isPricyConsent,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.isPricyConsent = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.isPricyConsent = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.isPricyConsent = $$c
                  }
                }
              }
            }),
            _vm._v("プライバシーポリシーと利用規約に同意する\n      ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "action_area" }, [
            _c(
              "button",
              { attrs: { type: "button" }, on: { click: _vm.candel } },
              [_vm._v("戻る")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                class: { disabled: !_vm.isUploadEnable },
                attrs: { type: "button" },
                on: { click: _vm.confirm }
              },
              [_vm._v("アップロード")]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("dd-footer"),
      _vm._v(" "),
      _c("dd-loading-modal", { ref: "loadingModalRef" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1bafaa5b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bafaa5b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/pages/UploadConfirm.vue
// module id = null
// module chunks = 